module.exports = __webpack_public_path__ + "img/footer-logo-2.e20cab79.png";